import { FormProvider, UseFormReturn } from 'react-hook-form';

import { ConfirmDrawer } from '@/components/Layout/Drawer/ConfirmDrawer';

import { useTranslate } from '@/hooks/useTranslate';

import { getDataTestId } from '@/utils/browser';

import UpdatePersonalInfoForm from './components/UpdateContactDetailCard';
import UpdateEmploymentForm from './components/UpdateEmploymentDetailsCard';
import { UpdatePersonalInfo as UpdatePersonalInfoFormType } from './types';

import {
  ButtonRow,
  UpdatePersonalInfoFormContainer,
  UpdatePersonalInfoFormSubmitButton,
} from './UpdatePersonalInfo.styled';

type UpdatePersonalInfoProps = {
  onConfirm: () => void;
  onSubmit: () => void;
  isPending: boolean;
  isValid: boolean;
  isOpenConfirmPopup: boolean;
  closeConfirmPopup: () => void;
  methods: UseFormReturn<UpdatePersonalInfoFormType>;
  onCancel?: () => void;
};

export function UpdatePersonalInfo({
  onConfirm,
  onSubmit,
  isPending,
  isValid,
  isOpenConfirmPopup,
  methods,
  closeConfirmPopup,
  onCancel,
}: Readonly<UpdatePersonalInfoProps>) {
  const { t } = useTranslate();

  return (
    <>
      <FormProvider {...methods}>
        <UpdatePersonalInfoFormContainer onSubmit={onSubmit}>
          <UpdatePersonalInfoForm />
          <UpdateEmploymentForm />
          <ButtonRow>
            <UpdatePersonalInfoFormSubmitButton
              {...getDataTestId(`update-personal-form-confirmbutton`)}
              fullWidth
              type="submit"
              variant="contained"
              disabled={!isValid || isPending}
            >
              {t('updatePersonalInfo.form.button.saveAndContinue')}
            </UpdatePersonalInfoFormSubmitButton>
            {onCancel && (
              <UpdatePersonalInfoFormSubmitButton
                {...getDataTestId(`update-personal-form-cancelbutton`)}
                fullWidth
                type="button"
                variant="outlined"
                onClick={onCancel}
              >
                {t('common.cancel')}
              </UpdatePersonalInfoFormSubmitButton>
            )}
          </ButtonRow>
        </UpdatePersonalInfoFormContainer>
      </FormProvider>
      {isOpenConfirmPopup && (
        <ConfirmDrawer
          icon="info"
          title={t('updatePersonalInfo.continueConfirm.title')}
          description={t('updatePersonalInfo.continueConfirm.description')}
          primaryAction={onConfirm}
          primaryText={t('updatePersonalInfo.continueConfirm.primaryText')}
          secondaryAction={closeConfirmPopup}
          secondaryText={t('updatePersonalInfo.continueConfirm.secondaryText')}
          onClose={closeConfirmPopup}
        />
      )}
    </>
  );
}
